import { render, staticRenderFns } from "./MappingsTable.vue?vue&type=template&id=469fa546&"
import script from "./MappingsTable.vue?vue&type=script&lang=js&"
export * from "./MappingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports